import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderQueryRequestImplEncoder } from "../../encoder/OrderQueryRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OrderQueryRequest } from "../OrderQueryRequest";

export class OrderQueryRequestImpl extends ConcreteEncodable implements OrderQueryRequest {
  public static enType: string = "com.bcdfx.model.event.OrderQueryRequestImpl";

  /*FID=1*/
  public fetchMode: CubiqTS.OrderQueryFetch;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=500*/
  public queryGroup: CubiqTS.QueryGroup | null = null;
  /*FID=501*/
  public maxResponseSize: number;
  /*FID=502*/
  public maxTotalResults: number;
  /*FID=503*/
  public querySort: CubiqTS.QuerySort | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderQueryRequestImplEncoder.Instance;
    this.setEncodableType(OrderQueryRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OrderQueryRequestImpl[" +
      "fetchMode=" +
      this.fetchMode +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "queryGroup=" +
      this.queryGroup +
      "maxResponseSize=" +
      this.maxResponseSize +
      "maxTotalResults=" +
      this.maxTotalResults +
      "querySort=" +
      this.querySort +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
